import React, { useState, useMemo, useEffect } from "react";
import { Subscription } from "../../pages";
import SubscriptionController from "../../controllers/SubscriptionController";
import { toJS } from "mobx";
import { subscriptionStore } from "../../stores";

const SubscriptionContainer = () => {
  //   usequery method start
  const [loading, setLoading] = useState(false);
  const [giveSubscriptionModal, setGiveSubscriptionModal] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const subscriptionTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}&isSubscribed=${true}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } =
    SubscriptionController.useGetSubscriptions(
      subscriptionTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  useEffect(() => {
    const setSubscriptionAnalysis = async () => {
      setLoading(true);
      await SubscriptionController.subscriptionAnalysis();
      setLoading(false);
    };
    setSubscriptionAnalysis();
  }, []);

  const goToGiveSubscription = () => {
    setGiveSubscriptionModal(true);
  };

  const closeModal = () => {
    setGiveSubscriptionModal(false);
  };

  return (
    <Subscription
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      onLimitChange={onLimitChange}
      setFilterQuery={setFilterQuery}
      setSearchQuery={setSearchQuery}
      limit={limit}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      loading={loading}
      subscriptionAnalysis={toJS(subscriptionStore.subscriptionAnalysis)}
      goToGiveSubscription={goToGiveSubscription}
      giveSubscriptionModal={giveSubscriptionModal}
      closeModal={closeModal}
    />
  );
};

export default SubscriptionContainer;
